import { render, staticRenderFns } from "./BRMatchCardDetails.vue?vue&type=template&id=e5215616&"
import script from "./BRMatchCardDetails.vue?vue&type=script&lang=js&"
export * from "./BRMatchCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./BRMatchCardDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports